// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ulbgbBaixdYFCpc4tUrm{flex-direction:column;display:flex}.ulbgbBaixdYFCpc4tUrm .wGdrQ126PhEN5eH4ZKMk{color:var(--content-primary-tertiary);justify-content:flex-end;align-self:stretch;gap:8px;padding:16px 38px 16px 0;display:flex}.ulbgbBaixdYFCpc4tUrm.TXysXyXnOVwX4Fv17KqK{align-items:flex-end}.ulbgbBaixdYFCpc4tUrm.TXysXyXnOVwX4Fv17KqK .wGdrQ126PhEN5eH4ZKMk{padding:16px 0}.ulbgbBaixdYFCpc4tUrm .idwj5ZWZAIWsR5yEStBe{align-items:center;display:flex}.ulbgbBaixdYFCpc4tUrm .PAMAw_WJdxUJkp1k_Z3K{color:var(--content-primary-tertiary);margin:0 6px 0 12px}.ulbgbBaixdYFCpc4tUrm .hF8LbIZVLMcAAqh0IZU6{margin-right:12px}.BUADWQ9kJIUvHuNfe3xw{text-align:right}.ZHEB8xiZtoECZuEmcTZw{white-space:nowrap}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `ulbgbBaixdYFCpc4tUrm`,
	"content": `wGdrQ126PhEN5eH4ZKMk`,
	"conversationHistory": `TXysXyXnOVwX4Fv17KqK`,
	"avatarWrap": `idwj5ZWZAIWsR5yEStBe`,
	"icon": `PAMAw_WJdxUJkp1k_Z3K`,
	"name": `hF8LbIZVLMcAAqh0IZU6`,
	"text": `BUADWQ9kJIUvHuNfe3xw`,
	"date": `ZHEB8xiZtoECZuEmcTZw`
};
export default ___CSS_LOADER_EXPORT___;
